import { type FormMode } from "../useCreateIngredientForm";
import { AdvancedForm } from "./advanced";
import { SimpleDairyForm } from "./simple-dairy";
import { SimpleAlcoholForm } from "./simple-alcohol";
import { SimpleSweetenerForm } from "./simple-sweetener";
import { SimpleStabilizerForm } from "./simple-stabilizer";
import { SimpleChocolateForm } from "./simple-chocolate";
import { UseFormReturn } from "react-hook-form";
import { CreateIngredientFormData } from "./schema";
import { IngredientCategory } from "@/lib/types";
import { SimpleEmulsifierForm } from "./simple-emulsifier";
import { NutritionForm } from "./nutrition";

interface CreateIngredientFormProps {
  form: UseFormReturn<CreateIngredientFormData>;
  formMode: FormMode;
  selectedCategory: IngredientCategory;
}

export function CreateIngredientForm({
  form,
  formMode,
  selectedCategory,
}: CreateIngredientFormProps) {
  if (formMode === "advanced") {
    return <AdvancedForm form={form} selectedCategory={selectedCategory} />;
  }

  if (formMode === "nutrition") {
    return <NutritionForm form={form} selectedCategory={selectedCategory} />;
  }

  switch (selectedCategory) {
    case "dairy":
      return <SimpleDairyForm form={form} />;
    case "alcohol":
      return <SimpleAlcoholForm form={form} />;
    case "sweetener":
      return <SimpleSweetenerForm form={form} />;
    case "chocolate":
      return <SimpleChocolateForm form={form} />;
    case "emulsifier":
      return <SimpleEmulsifierForm form={form} />;
    case "stabilizer":
      return <SimpleStabilizerForm form={form} />;
    default:
      return (
        <AdvancedForm
          form={form}
          isDisabled={false}
          selectedCategory={selectedCategory}
        />
      );
  }
}
